// START_MODULE pages_main_sections_news_news_tsx
// START_CONTRACT
// PURPOSE: Preserve this module from the original Tomsk Data Science frontend.
// OPERATIONAL_CONTEXT: Imported by the public static React application.
// CONTRACT: Keep manual news navigation but render it without entrance or slide transition animation.
// KEYWORDS: legacy-frontend, static-site, tomsk-data-science
// COMPLEXITY: 2
// END_CONTRACT
import React from 'react';
import { Pagination, Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useNavigate } from 'react-router-dom';

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

import NewsItem from './components/newsItem/NewsItem';
import { MoreNewsButton } from './styled';

import ArrowRight from 'components/atoms/icons/ArrowRight';
import { ContentSectionContainer } from 'components/layout/contentSectionContainer/ContentSectionContainer';

import { INews } from 'domain/entities/INews';

import { route } from 'routes/route';
import { Section } from 'routes/section';

interface NewsSectionProps {
  news: INews[];
}

const NewsSection: React.FC<NewsSectionProps> = ({ news }) => {
  const navigate = useNavigate();

  return (
    <ContentSectionContainer id={Section.NEWS} type="middle">
      <h4>Недавние новости</h4>
      <div>
        <Swiper
          slidesPerView="auto"
          spaceBetween={30}
          speed={0}
          pagination={{ clickable: true }}
          modules={[Pagination, Navigation]}
          className="mySwiper"
          navigation
        >
          {
            news.map((newsItem) => (
              <SwiperSlide key={newsItem.id} style={{ width: 'fit-content' }}>
                <NewsItem news={newsItem} />
              </SwiperSlide>
            ))
          }
        </Swiper>
      </div>
      <MoreNewsButton onClick={() => navigate(route.news)}>
        Больше новостей
        <ArrowRight />
      </MoreNewsButton>
    </ContentSectionContainer>
  );
};

export default NewsSection;

// END_MODULE pages_main_sections_news_news_tsx
